import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import Image from 'next/image'
import { Typography, Button } from '@material-ui/core'

const defaultBenefits = [
  {
    image: '/svg/benefits/thumbs-up.svg',
    text: 'Participate in the growth of the Cryptotesters community',
    highlight: 'Participate',
  },
  {
    image: '/svg/benefits/price-tag.svg',
    text: 'Unlock exclusive discounts & perks across DeFi & Web3',
    highlight: 'Unlock',
  },
  {
    image: '/svg/benefits/usability.svg',
    text: 'Forge valuable connections in a network of builders & investors',
    highlight: 'Forge',
  },
  {
    image: '/svg/benefits/stand-up.svg',
    text: 'Access our private Discord & Telegram and get high-signal information',
    highlight: 'Access',
  },
  {
    image: '/svg/benefits/chat.svg',
    text: 'Early exclusive access to DeFi & Web3 projects',
    highlight: 'Early',
  },
  {
    image: '/svg/benefits/prioritize-up.svg',
    text: 'Monthly community events & calls with founders',
    highlight: 'Monthly community events & calls',
  },
  {
    image: '/svg/benefits/users.svg',
    text: 'Get airdrop alpha by the people behind @DeFi_airdrops',
    highlight: 'Get airdrop alpha',
  },
  {
    image: '/svg/benefits/users.svg',
    text: 'Community managed calendar to stay on top of project launches',
    highlight: 'Community managed calendar',
  },
]

const useStyles = makeStyles((theme) => ({
  benefitSection: {
    margin: '4rem 0',
  },
  benefits: {
    display: 'grid',
    margin: '2rem 0',
    gap: '2rem',
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.up('md')]: {
      '&.top': {
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
      },
      '&.bottom': {
        gridTemplateColumns: '1fr 1fr 1fr',
      },
    },
  },
  benefit: {
    padding: '1rem',
    background: 'rgba(0, 0, 0, 0.04)',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    color: 'black',
  },
  benefitImage: {
    width: '100%',
    position: 'relative',
    height: '50px',
  },
  benefitText: {
    color: '#7D7787',
    fontSize: '1rem',
    fontWeight: 'normal',
    '& span': {
      color: '#2B1841',
    },
  },
  sectionTitle: {
    color: 'black',
    letterSpacing: '-0.02em',
  },
}))

function Benefits(): JSX.Element {
  const classes = useStyles({})
  const benefits = defaultBenefits
  return (
    <section className={classes.benefitSection}>
      <Typography variant="h3" className={classes.sectionTitle}>
        Benefits of the community
      </Typography>
      <div className={`${classes.benefits} bottom`}>
        {benefits.slice(0, 9).map((benefit, index) => {
          return (
            <div key={index} className={classes.benefit}>
              <div className={classes.benefitImage}>
                <Image height={40} width={40} src={`${benefit.image}`} />
              </div>
              <Typography variant="body1" className={classes.benefitText}>
                <span>{benefit.highlight}</span> {benefit.text.replace(benefit.highlight, '')}
              </Typography>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Benefits
